export enum OrderTimeWindowType {
  INTERVAL = 'interval',
  FIX = 'fix',
  OPENING_HOURS = 'opening-hours',
}
